export enum BulkOperationStatusEnum {
    pending,
    processing,
    completed,
    failed,
    partiallyCompleted,
    cancelled
}
